import { createBrowserHistory } from 'history';

const historyObject = createBrowserHistory({ window });
export default historyObject;
